/**
 * Custom event that lifts a widget into keyboard move mode. Dispatched by
 * the widget name-chip handle and the Anvil command palette's "Move widget"
 * command; consumed by KeyboardMoveController (mounted in AnvilEditorCanvas).
 * Same decoupling pattern as DETACHED_WIDGET_MOUSE_MOVE_EVENT.
 */
export const ANVIL_KEYBOARD_MOVE_START_EVENT = "anvil-keyboard-move-start";

export interface AnvilKeyboardMoveStartDetail {
  widgetId: string;
}

export function startKeyboardMove(widgetId: string) {
  document.dispatchEvent(
    new CustomEvent<AnvilKeyboardMoveStartDetail>(
      ANVIL_KEYBOARD_MOVE_START_EVENT,
      { detail: { widgetId } },
    ),
  );
}
